/**
 * AdSense runtime loader.
 *
 * Reads REACT_APP_ADSENSE_CLIENT from build-time env. When it's a valid
 * "ca-pub-XXXXXXXXXXXXXXXX" publisher ID, injects the adsbygoogle script
 * once and exposes the client ID. Otherwise no-op (dev/preview mode —
 * AdSlot renders a placeholder).
 */
const CLIENT = (process.env.REACT_APP_ADSENSE_CLIENT || "").trim();
const IS_VALID = /^ca-pub-\d{10,20}$/.test(CLIENT);

let loaded = false;

export const getAdsenseClient = () => (IS_VALID ? CLIENT : "");

export const isAdsenseEnabled = () => IS_VALID;

export const loadAdsense = () => {
  if (!IS_VALID || loaded || typeof window === "undefined") return;
  // Avoid double-injection on hot reload
  if (document.querySelector('script[data-adsense="1"]')) {
    loaded = true;
    return;
  }
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
  s.setAttribute("data-adsense", "1");
  document.head.appendChild(s);
  loaded = true;
};

export const pushAd = () => {
  if (!IS_VALID || typeof window === "undefined") return;
  try {
    window.adsbygoogle = window.adsbygoogle || [];
    window.adsbygoogle.push({});
  } catch (_) {
    /* noop — adsbygoogle may not be ready yet */
  }
};
